module.exports = __webpack_public_path__ + "img/图层 5.8b5e5323.png";